import React, { useEffect, useRef } from "react";
import {
  BrowserRouter,
  Link,
  Redirect,
  Route,
  Switch,
  useHistory,
  useLocation,
} from "react-router-dom";
import SiteHeader from "./SiteHeader";
import SiteMeta from "./SiteMeta";
import Home from "./Home";
import Projects from "./Projects";
import About from "./About";
import Contact from "./Contact";
import Resume from "./Resume";
import { profile } from "./content";
import "./site.css";

function RoutePosition() {
  const { pathname, hash, key } = useLocation();
  const history = useHistory();
  const firstVisit = useRef(true);
  useEffect(() => {
    // Let the browser restore the saved position on Back / Forward.
    // Moving focus with preventScroll keeps that restoration intact.
    if (!firstVisit.current && history.action === "POP") {
      document.getElementById("main-content").focus({ preventScroll: true });
      return;
    }
    const target = hash && document.getElementById(hash.slice(1));
    if (target) {
      target.scrollIntoView();
      target.focus({ preventScroll: true });
    } else {
      window.scrollTo(0, 0);
      if (!firstVisit.current)
        document.getElementById("main-content").focus({ preventScroll: true });
    }
    firstVisit.current = false;
  }, [pathname, hash, key, history]);
  return null;
}

function NotFound() {
  return (
    <>
      <SiteMeta title="Page not found" noindex />
      <section className="page-intro not-found">
        <p className="error-code">404</p>
        <h1>
          Page not found<span>.</span>
        </h1>
        <p>
          This link doesn’t lead anywhere. There’s plenty to explore back on the
          homepage.
        </p>
        <Link className="button" to="/">
          Back to home
        </Link>
      </section>
    </>
  );
}

function SiteFooter() {
  return (
    <footer className="site-footer wrap">
      <div>
        <Link className="footer-name" to="/">
          Hunter Grey
        </Link>
        <span>Always a work in progress.</span>
      </div>
      <nav aria-label="Footer navigation">
        <a href={profile.github} target="_blank" rel="noopener noreferrer">
          GitHub
        </a>
        <a href={profile.gitlab} target="_blank" rel="noopener noreferrer">
          GitLab
        </a>
        <a href={`mailto:${profile.email}`}>Email</a>
        <Link to="/resume">Résumé</Link>
      </nav>
      <a
        className="icp-link"
        href="https://beian.miit.gov.cn/"
        target="_blank"
        rel="noopener noreferrer"
      >
        闽ICP备2023001855号
      </a>
    </footer>
  );
}

export default function Site() {
  return (
    <BrowserRouter>
      <a className="skip-link" href="#main-content">
        Skip to content
      </a>
      <SiteHeader />
      <main className="site-main wrap" id="main-content" tabIndex={-1}>
        <Switch>
          <Redirect exact from="/home" to="/" />
          <Redirect exact from="/experience" to="/about#experience" />
          <Redirect exact from="/education" to="/about#education" />
          <Redirect exact from="/opensource" to="/projects" />
          <Route exact path="/" component={Home} />
          <Route exact path="/projects" component={Projects} />
          <Route exact path="/about" component={About} />
          <Route exact path="/contact" component={Contact} />
          <Route exact path="/resume" component={Resume} />
          <Route component={NotFound} />
        </Switch>
      </main>
      <SiteFooter />
      <RoutePosition />
    </BrowserRouter>
  );
}
